export default Object.freeze({
  PERFIL_PREFEITOP: 'Prefeitop',
  PARAMETRO_VIDEOWALL: 'full', // https://homolog.backend.sp360.pmsp -- https://homolog.backend.sp360.pmsp/api/v1 //10.32.145.51 murillo http://SMITGBC031:55360
  DOMINIO_INTERNO: 'pmsp',
  VERSAO_FRONTEND: require('/package').version,
  URL_INTERNA_BASE: (() => {
    if (process.env.VUE_APP_BUILD === 'development') return 'http://SMITGBC031:55360' // Não usar localhost como nome
    else if (process.env.VUE_APP_BUILD === 'production') return 'https://backend.sp360.pmsp'
    else return 'https://homolog.backend.sp360.pmsp'
  })(),
  URL_EXTERNA_BASE: (() => {
    if (process.env.VUE_APP_BUILD === 'development') return 'http://SMITGBC031:55360' // Não usar localhost como nome
    else if (process.env.VUE_APP_BUILD === 'production') return 'https://backend.sp360.prefeitura.sp.gov.br'
    else return 'https://homolog.backend.sp360.prefeitura.sp.gov.br'
  })(),
  TOASTED_SUCCESS: { theme: 'primary', type: 'success', icon: 'fa-check', position: 'top-left', duration: 3000, fullWidth: false },
  TOASTED_ERROR: { theme: 'primary', type: 'error', icon: 'fa-times', position: 'top-left', duration: 3000, fullWidth: false },
  TOASTED_INFO: { theme: 'primary', type: 'info', icon: 'fa-info', position: 'top-left', duration: 3000, fullWidth: false },
  TOASTED_ALERT: { theme: 'primary', type: 'alert', icon: 'fa-exclamation-triangle', position: 'top-left', duration: 3000, fullWidth: false },
  VALIDAR_PERMISSAO_PARAMETRO_FULL_SCREEN: false, // Caso seja verdadeiro, apenas usuários com o perfil PERFIL_PREFEITOP poderão ver o ícone de cópia de URL.
  TEMPO_ATUALIZACAO_PRADAO: 3600000, // 1hr
  LINK_IFRAME: {
    ASSISTENCIA_SOCIAL: {
      OCUPACAO_ABRIGOS: 'LINK_IFRAME_OCUPACAO_ABRIGOS',
      VAGAS_CONTRATADAS: 'LINK_IFRAME_VAGAS_CONTRATADAS',
    },
    CRISE: {
      CORONA_VIRUS: 'LINK_IFRAME_CRISE_CORONA_VIRUS',
      CORONA_VIRUS_COMPRAS: 'LINK_IFRAME_CRISE_CORONA_VIRUS_COMPRAS',
      CORONA_VIRUS_DOACOES: 'LINK_IFRAME_CRISE_CORONA_VIRUS_DOACOES',
      CORONA_VIRUS_SOCIAL: 'LINK_IFRAME_CRISE_CORONA_VIRUS_SOCIAL',
    },
    DIREITOS_HUMANOS: {
      REDE_SERVICO: 'LINK_IFRAME_SERVICOS_DIREITOS_HUMANOS',
    },
    LICENCIAMENTO_EMPRESA: {
      SOLICITACAO_SETORES: 'LINK_IFRAME_LICENCIAMENTO_EMPRESA_SOLICITACAO_SETORES',
    },
    METAS: {
      STATUS_PROGRAMA_METAS: 'LINK_IFRAME_STATUS_PROGRAMA_METAS',
    },
    MOBILIDADE: {
      MAPA_TRANSITO: 'LINK_IFRAME_MAPA_TRANSITO',
    },
    ORCAMENTO: {
      ORCAMENTO_CONSOLIDADO: 'LINK_IFRAME_ORCAMENTO_CONSOLIDADO',
      ORCAMENTO_ORGAO: 'LINK_IFRAME_ORCAMENTO_ORGAO',
      ORCAMENTO_FUNCOES_GOVERNO: 'LINK_IFRAME_ORCAMENTO_FUNCOES_GOVERNO',
      ORCAMENTO_FONTE_RECURSOS: 'LINK_IFRAME_ORCAMENTO_FONTE_RECURSOS',
      ORCAMENTO_NATUREZA_DESPESAS: 'LINK_IFRAME_ORCAMENTO_NATUREZA_DESPESAS',
    },
    POPULACAO: { AUXILIO_ALUGUEL: 'LINK_IFRAME_AUXILIO_ALUGUEL' },
  },
  PARAMETROS_DASHBOARD: {
    CANAIS_DE_ENTRADA: {
      TOLERANCIAS: {
        TMA_ALTO: 100,
        TAXA_FINALIZACAO: 60, // %
      },
    },
    MOBILIDADE: {
      QTD_DE_LOCAIS_CONGESTIONADOS: 200,
      GMAP_API_KEY: 'AIzaSyA2JyZ2nhUSZt4CV8a_NtcQS_8NNSPDPKU',
      GMAP_CENTER: { lat: -23.590522, lng: -46.6522266 }, // -23.590522,-46.6522266
      GMAP_ZOOM: 11,
      GMAP_ZOOM_SME: 10,
    },
    SP156: {
      QTD_BARRAS_SOLICITACOES_30D: 8,
      QTD_BARRAS_SOLICITACOES_POR_ORGAO: 10,
      QTD_DE_LINHAS_TABELAS_SERVICO_POR_REGIAO: 10,
      QTD_SERVICOS_POR_REGIAO_ESTOQUE_REQUEST: 10,
      QTD_SERVICOS_POR_REGIAO_ULTIMO_MES_REQUEST: 10,
      QTD_SERVICOS_POR_REGIAO_ULTIMO_SEMESTRE_REQUEST: 10,
      QTD_DE_LINHAS_TABELAS_SOLICITACOES_POR_ORGAO_ULTIMO_MES: 50,
      QTD_DE_MESES_GRAFICO_LINHA_SOLICITACOES_FINALIZADAS: 38,
      QTD_DE_PONTOS_GRAFICO_LINHA_EVOLUCAO_ESTOQUE_SOLICITACAO: 120,
    },
    SME: {
      INTERVALO: {
        ULTIMO_ANO: 'ULTIMO_ANO',
        ULTIMO_SEMESTRE: 'ULTIMO_SEMESTRE',
        ULTIMO_MES: 'ULTIMO_MES',
        ULTIMA_SEMANA: 'ULTIMA_SEMANA',
        MAIS_RECENTE: 'MAIS_RECENTE',
        DESDE_SEMPRE: 'DESDE_SEMPRE',
      },
      AGRUPAMENTO: {
        POR_TIPO_ESCOLA: 'POR_TIPO_ESCOLA',
        POR_CICLO_ENSINO: 'POR_CICLO_ENSINO',
      },

    },
    SAUDE: {
      ESTOQUE_MEDICAMENTOS: {
        TAMANHO_TABELAS: 40,
        RANGE: {
          IDEAL: 90,
          BOM: 60,
          REGULAR: 30,
          CRITICO: 0,
        },
      },
    },
    MANAGEMENT: {
      TAMANHO_TABELAS: 8,
    },
    FOLHA_PAGAMENTO: {
      HISTORICO_SERVIDORES: {
        HISTORICO_ADMISSAO_VACANCIA_TAXA_TAMANHO_GRAFICO: 3 / 4,
        HISTORICO_ADMISSAO_VACANCIA_DATA_INICIO_DATASETS: 1990,
        HISTORICO_ADMISSAO_APOSENTADORIA_VACANCIA_BARCHART_TAM: 20,
      },
    },
  },
  JSONEDITOR_LOCALIZACAO: {
    'pt-BR': {
      undo: 'Desfazer última ação (Ctrl+Z)',
      searchTitle: 'Procurar campos e valores',
      searchNextResultTitle: 'Próximo resultado (Enter)',
      searchPreviousResultTitle: 'Resultado anterior (Shift + Enter)',
      extract: 'Extrair',
      extractTitle: 'Extrair esse ${type}',
      autoType: 'Tipo de campo "auto".',
      modeEditorTitle: 'Mudar tipo de editor',
      modeCodeText: 'Código',
      modeCodeTitle: 'Mudar para o editor de código (JSON)',
      modeFormText: 'Formulário',
      modeFormTitle: 'Mudar para o editor de formulário',
      modeTextText: 'Texto',
      modeTextTitle: 'Mudar para o editor de texto',
      modeTreeText: 'Árvore',
      modeTreeTitle: 'Mudar para o editor de árvore',
      modeViewText: 'View',
      modeViewTitle: 'Mudar para tree view',
      modePreviewText: 'pré-visualização',
      modePreviewTitle: 'Mudar para modo de pré-visualização',
    },
  },
})